import React from 'react';
import styled from 'styled-components';

import ModelPicture from './ModelPicture';
import { formatBigNumber } from '../../../helpers';
import './Model.css';

const Info = styled.div`
  font-family: BrandonGrotesque-Regular, sans-serif;
  font-size: 14px;
  line-height: 130%;
  letter-spacing: 1px;
  color: var(--color-cool-grey);
`;

const Box = styled.div`
  display: flex;
`;

const Link = styled.span`
  color: var(--color-khaki);
  text-decoration: underline;
`;

function ModelBox(props: { model: Model; alignment: boolean }) {
  const modelPicture = <ModelPicture image={props.model.avatar} />;

  const modelInfo = (
    <Info>
      <span className="model-name">{props.model.name}</span>
      <br />
      <a
        href={props.model.instagram && props.model.instagram.profile_url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Link>{props.model.instagram ? `@${props.model.instagram.handle}` : ''}</Link>
      </a>
      <br />
      <span>
        {props.model.instagram &&
          formatBigNumber(props.model.instagram.number_of_followers) + ' followers'}
      </span>
    </Info>
  );

  return (
    <div className="col-md-4">
      {props.alignment ? (
        <Box>
          <div className="model-box-item model-text-left">{modelInfo}</div>
          <div className="model-box-item">{modelPicture}</div>
        </Box>
      ) : (
        <Box>
          <div className="model-box-item" style={{ width: 'auto' }}>
            {modelPicture}
          </div>
          <div className="model-box-item model-text-right">{modelInfo}</div>
        </Box>
      )}
    </div>
  );
}

export default ModelBox;
